.banner-root {
    transition: all 0.2s ease;
}

.banner-click-target:hover :global(button:not([disabled])) {
    text-decoration: underline;
}
